import React, { useEffect, useCallback } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import DashboardLayout from "./components/DashboardLayout";
import Login from "./components/Login.js";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { jwtDecode } from "jwt-decode";
import "./index.css";
import "./i18n";
import CustomerOrderRequest from "./screens/CustomerOrderRequest.js";
import Products from "./screens/Products.js";
import OrderReceiptPage from "./screens/OrderReceiptPage.js";
import InvoiceView from "./components/InvoiceView.js";
import AddReceivedStockOnLoan from "./screens/AddReceivedStockOnLoan.js";

function App() {
  const navigate = useNavigate();

  // Function to validate token expiration
  const validateToken = useCallback(() => {
    const currentPath = window.location.pathname;
  
    // Skip token validation for /endcustomer and /order-receipt
    if (currentPath === "/endcustomer" || currentPath === "/order-receipt" || currentPath === "/invoiceView") {
      return;
    }
  
    const token = sessionStorage.getItem("token");
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        if (Date.now() >= decodedToken.exp * 1000) {
          sessionStorage.clear();
          navigate("/login");
          return false;
        }
        return true;
      } catch (error) {
        console.error("Invalid token:", error);
        sessionStorage.clear();
        navigate("/login");
        return false;
      }
    } else {
      navigate("/login");
      return false;
    }
  }, [navigate]);
  
  useEffect(() => {

    const currentPath = window.location.pathname;

    if (
        currentPath.startsWith("/companyadmin-dashboard") ||
        currentPath.startsWith("/pettycash") ||
        currentPath.startsWith("/products") ||
        currentPath.startsWith("/add-received-stock-on-loan")
    ) {
      return;
    }

    if (
        currentPath === "/login" ||
        currentPath === "/endcustomer" ||
        currentPath === "/order-receipt" ||
        currentPath === "/invoiceView"
    ) {
      return;
    }

    const isAuthenticated = validateToken();
    if (!isAuthenticated) return;
  
    const userRole = sessionStorage.getItem("role");
    const userLocation = sessionStorage.getItem("location");
    const userOrganization = sessionStorage.getItem("organization");
  
    if (userRole === "Main Admin") {
      navigate(`/mainadmin-dashboard`);
    } else if (
        userRole === "Company Admin" ||
        userRole === "Farm User" ||
        userRole === "Outlet User" ||
        userRole === "Accountant") {
      navigate(
        `/companyadmin-dashboard?location=${userLocation}&organization=${userOrganization}`
      );
    } else if (userRole === "Default User") {
      navigate(`/user-dashboard`);
    } else {
      navigate("/login");
    }
  }, [validateToken, navigate]);
  
  return (
    <>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
            path="*"
            element={
              sessionStorage.getItem("token")
                  ? <DashboardLayout />
                  : <Login />
            }
        />
        <Route path="/products" element={<Products />} />
        <Route path="/endcustomer" element={<CustomerOrderRequest />} />
        <Route path="/order-receipt" element={<OrderReceiptPage />} />
        <Route path="/invoiceView" element={<InvoiceView />} />
        <Route path="/add-received-stock-on-loan" element={<AddReceivedStockOnLoan />} />
      </Routes>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}

export default App;
